import 'twin.macro';
import { flexRender } from '@tanstack/react-table';
import React, { Fragment } from 'react';

interface Props {
  tableInstance: any;
  action?: any;
}

export function MobileList(props: Props) {
  const instance = props.tableInstance;
  return (
    <table tw="min-w-full divide-y divide-gray-300 rounded-lg">
      <tbody tw="divide-y divide-gray-200">
        {instance.getRowModel().rows.map(row => {
          const pictureCell = row
            .getAllCells()
            .find(c => c.column.id === 'picture');
          return (
            <tr key={row.id} className="group" tw="relative">
              <td tw="w-full max-w-0 py-4 md:pl-4 md:pr-3 text-sm font-medium text-neutral-intense">
                <div tw="flex justify-between gap-x-2">
                  <div tw="flex flex-grow">
                    <div tw="mr-4">
                      {flexRender(
                        pictureCell?.column?.columnDef.cell,
                        pictureCell?.getContext(),
                      )}
                    </div>
                    <div>
                      <div tw="mb-2.5">
                        {row.getValue('familyName')} {row.getValue('givenName')}
                      </div>
                      <dl tw="font-normal lg:hidden">
                        {row.getVisibleCells().map((cell, i) => {
                          if (
                            ['givenName', 'familyName', 'picture'].includes(
                              cell.column.id,
                            )
                          ) {
                            return null;
                          }
                          return (
                            <Fragment key={i}>
                              <dd tw="min-h-9 flex items-center">
                                <div tw="flex flex-wrap gap-x-3 items-center">
                                  <div tw="text-xs text-muted">
                                    {flexRender(
                                      cell.column.columnDef.header,
                                      cell.getContext(),
                                    )}
                                  </div>
                                  <div tw="text-neutral-intense">
                                    {flexRender(
                                      cell.column.columnDef.cell,
                                      cell.getContext(),
                                    )}
                                  </div>
                                </div>
                              </dd>
                            </Fragment>
                          );
                        })}
                      </dl>
                    </div>
                  </div>
                  {props.action({ id: row.original.id })}
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
